import React from 'react';
import { FormattedMessage } from 'react-intl';
import { rendererFor } from './registry';

export const UnsupportedChallenge = () => (
    <p className="hia-ack-note" data-testid="unsupported-challenge">
        <FormattedMessage id="conventionPage.challenge.unsupported" />
    </p>
);

// Dispatches a practice item to the renderer of its content type.
const ChallengeView = ({ item, highlights, blockSizes }) => {
    const Renderer = item && typeof item.content === 'string' ? rendererFor(item.contentType) : null;
    if (!Renderer) return <UnsupportedChallenge />;
    return <Renderer content={item.content} highlights={highlights} blockSizes={blockSizes} />;
};

export default ChallengeView;
